import type { GanttTooltipProps } from "./GanttTooltip.types";
import type { GanttTooltipDimensions } from "./useGanttTooltipDimensions";

const TOOLTIP_PADDING = 8;
const TOOLTIP_GAP = 10;

export interface GanttTooltipPosition {
  left: number;
  top: number;
}

interface GetGanttTooltipPositionParams {
  tooltip: NonNullable<GanttTooltipProps["tooltip"]>;
  tooltipDimensions: GanttTooltipDimensions;
}

export function getGanttTooltipPosition({
  tooltip,
  tooltipDimensions,
}: GetGanttTooltipPositionParams): GanttTooltipPosition {
  const viewportAnchorX = tooltip.anchorX - tooltip.scrollLeft;
  const viewportAnchorY = tooltip.anchorY - tooltip.scrollTop;

  const maxViewportLeft = Math.max(
    TOOLTIP_PADDING,
    tooltip.containerWidth - tooltipDimensions.width - TOOLTIP_PADDING,
  );
  const preferredViewportLeft = viewportAnchorX - tooltipDimensions.width / 2;
  const viewportLeft = Math.min(
    maxViewportLeft,
    Math.max(TOOLTIP_PADDING, preferredViewportLeft),
  );

  const maxViewportTop = Math.max(
    TOOLTIP_PADDING,
    tooltip.containerHeight - tooltipDimensions.height - TOOLTIP_PADDING,
  );
  const spaceAbove = viewportAnchorY - TOOLTIP_PADDING;
  const spaceBelow = tooltip.containerHeight - viewportAnchorY - TOOLTIP_PADDING;
  const shouldPlaceAbove =
    spaceAbove >= tooltipDimensions.height + TOOLTIP_GAP ||
    spaceAbove > spaceBelow;
  const preferredViewportTop = shouldPlaceAbove
    ? viewportAnchorY - tooltipDimensions.height - TOOLTIP_GAP
    : viewportAnchorY + TOOLTIP_GAP;
  const viewportTop = Math.min(
    maxViewportTop,
    Math.max(TOOLTIP_PADDING, preferredViewportTop),
  );

  const left = viewportLeft + tooltip.scrollLeft;
  const top = viewportTop + tooltip.scrollTop;

  return { left, top };
}
